import {
  AfterViewInit,
  Component,
  signal,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DialogPopupComponent } from '../dialog-popup/dialog-popup.component';
import { UserConfigurationService } from '../../services/userconfiguration/user-configuration.service';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';
import { PlatformService } from '../../services/platform-service/platform.service';

@Component({
  selector: 'feedback-popup',
  imports: [DialogPopupComponent, SafeUrlPipe],
  templateUrl: './feedback-popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './feedback-popup.component.scss',
})
export class FeedbackPopupComponent implements AfterViewInit {
  private static readonly FALLBACK_FEEDBACK_URL =
    'https://boschdigital.qualtrics.com/jfe/form/SV_et9eWrQTWuzZym2?Offering=NG+Portal&OfferingID=FB-0000055&Source=Popup&SourceCategory=Use&Stage=Prod&SurveyStyle=Flyout';
  private readonly popup = viewChild<DialogPopupComponent>('dialogPopup');
  protected readonly feedbackURL = signal(FeedbackPopupComponent.FALLBACK_FEEDBACK_URL);
  protected renderPopupContent = signal(false);

  constructor(
    private readonly configService: UserConfigurationService,
    private readonly platformService: PlatformService,
  ) {}

  ngAfterViewInit(): void {
    if (this.platformService.isMobile()) return;

    this.feedbackURL.set(this.configService.getOrDefault('FEEDBACK_URL'));

    const doShowPopup = this.configService.getOrDefault(
      this.configService.KEY_SHOW_FEEDBACK_POPUP,
      false,
    );

    if (doShowPopup) {
      this.popup()?.openDialog();
      this.renderPopupContent.set(true);
      this.configService.set(this.configService.KEY_SHOW_FEEDBACK_POPUP, false).subscribe();
    }
  }
}
